/**
 * 予約者名を表示言語に応じた氏名順に整形する。ja は「姓 名」、それ以外は「名 姓」。
 * 姓名いずれかが空でも成立させ、両方空なら空文字を返す (呼び出し側で宛名を出さない)。
 *
 * 同じ予約に対するメールの宛名は backend の
 * notification/adapter/out/template/renderer.go の formatGuestName が同じ規則で整形しているため、
 * メールと画面で並びが食い違わないよう規則を合わせる (JPTP_CANSEI-1570)。
 */
export function formatGuestName(lastName: string, firstName: string, language: string): string {
  const last = lastName.trim();
  const first = firstName.trim();
  if (!last && !first) return "";
  return (language === "ja" ? `${last} ${first}` : `${first} ${last}`).trim();
}
